<nav class="nav-container" id="nav">
    <div class="logo">
        <a routerLink="/" style="color: var(--font-color); text-decoration: none;"><span
                style="color: var(--accent-color);">Leon</span><span> Zimmermann</span></a>
    </div>
    <div class="social">
        <a class="avatar" [routerLink]="['lilly']">
            <img alt="Lilly Profil" src="../../assets/img/lilly-head-30x30.webp">
        </a>
        <a class="avatar" [routerLink]="['/']">
            <img alt="Leon Profil" src="../../assets/img/leon-head-30x30.webp">
        </a>
    </div>
</nav>
<div class="content">
    <ng-content></ng-content>
</div>